import Category from '@common/models/Category';
import Link from '@lib/Link';
import classnames from 'classnames';
import React, { useState } from 'react';

import SubCategorySidebarItem from './SubCategorySidebarItem';

interface CategorySidebarItemProps {
  category: Category;
}

const CategorySidebarItem: React.FC<CategorySidebarItemProps> = ({ category }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="w-full flex justify-between items-center">
        <Link to={category.storeLink}>
          <div
            className="text-16 font-bold tracking-16 uppercase"
            font-customisation="section-heading"
            color-customisation="page-heading"
          >
            {category.name}
            {/* {category.childCategories?.length > 0 ? <span>({category.childCategories?.length})</span> : null} */}
          </div>
        </Link>
        <div
          className={classnames('justify-self-end inline-block font-semibold text-24 text-theme', {
            'text-label': !isOpen,
            invisible: !category.childCategories?.length,
            'cursor-pointer': category.childCategories?.length,
          })}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? '-' : '+'}
        </div>
      </div>
      {isOpen &&
        category.childCategories?.map((category) => (
          <div className="my-16 -ml-10" key={category.id}>
            {category?.childCategories?.length ? (
              <div className="pl-10 w-full text-14 md:text-16 cursor-pointer hover:font-bold hover:text-theme font-medium text-disabledtext">
                <SubCategorySidebarItem category={category} />
              </div>
            ) : (
              <Link to={category.storeLink}>
                <div
                  className="p-6 px-10 w-full text-14 md:text-16 cursor-pointer hover:font-bold hover:text-theme font-medium text-disabledtext"
                  font-customisation="para-text"
                  color-customisation="page-body-text"
                >
                  {category.name}
                </div>
              </Link>
            )}
          </div>
        ))}
    </>
  );
};

export default CategorySidebarItem;
